<template>
	<div>
		<b-modal
			id="interviewSlot"
			modal-class="bottom-modal"
			hide-footer
			hide-header
			no-close-on-backdrop
			v-model="openModal"
			@hidden="$emit('closeSlots')"
		>
			<main>
				<section class="interslot-body">
					<h2 class="fam-mont appr-modal-heading mb-3">
						<span>Select an interview slot</span>
					</h2>
					<img
						@click="$emit('closeSlots')"
						class="interslot-cross rotate-on-hover pointer"
						src="../../assets/newdesign/myprofile/greyCross.svg"
						alt=""
					/>
					<article>
						<span>
							Select a preferred time slot for your interview from the available
							options.
						</span>
					</article>

					<div class="d-flex my-3">
						<span class="fam-mont fw-LM fs-16">Available Slots</span>
						<!-- cancel interview -->
						<span
							class="cancel-interview ml-auto pointer"
							v-if="
								!isPanel &&
								selectedJob.slotStatus == 2 &&
								selectedJob.reschedule
							"
							@click="cancelInterview"
							>Cancel Interview</span
						>
					</div>

					<section class="position-relative">
						<div class="select-date-parent pb-4">
							<div
								v-for="(slot, index) in availableSlots"
								:key="index"
								@click="selectDate(slot)"
								class="single-time-date pointer"
								:class="selectedDate === slot ? 'single-time-sel' : ''"
							>
								<h2 class="fam-mont fw-LM fs-14 text-black text-center">
									{{ slot.day }}
								</h2>
								<h3 class="fam-mont fw-R fs-13 text-darkgrey mb-0 text-center">
									{{ slot.date }}
								</h3>
							</div>
						</div>
						<img
							@click="scrollLeft"
							class="select-date-left"
							src="../../assets/newdesign/jobsearch/carouselLeft.svg"
							alt=""
						/>
						<img
							@click="scrollRight"
							class="select-date-right"
							src="../../assets/newdesign/jobsearch/carouselRight.svg"
							alt=""
						/>
					</section>

					<div class="time-select-parent">
						<div
							v-for="(time, index) in availableTimes"
							:key="index"
							@click="selectTime(time)"
							class="single-time pointer"
							:class="selectedTime === time ? 'single-time-sel' : ''"
						>
							{{ time }}
							<!-- vertical line should come after first and secind one -->
							<div
								v-if="(index + 1) % 3 != 0"
								class="single-time-vertical-line"
							></div>
						</div>
					</div>
				</section>

				<footer
					class="d-flex align-items-center justify-content-between candash-modal-footer"
				>
					<div>
						<div class="fam-lato fs-14 fw-LM text-grey">Slot details:</div>
						<div class="fam-lato fs-16 fw-B text-blue">
							{{
								selectedDate && selectedDate.date
									? formattedDate(selectedDate.date)
									: "Select a date"
							}},
							{{ selectedTime ? "Starts " + selectedTime : "Select a time" }}
						</div>
					</div>
					<b-button
						class="candash-addBtn"
						@click="confirmSelection"
						:disabled="!selectedDate || !selectedTime"
					>
						{{ parentMessage }}
					</b-button>
				</footer>
			</main>
		</b-modal>
	</div>
</template>

<script>
import {
	saveInterviewSlot,
	saveInterviewSlotPanel,
	cancelInterviewRequest,
} from "@/utils/apiFunctions.js";
import toast from "../mixin/toast";
export default {
	name: "InterviewSlotModal",
	props: {
		isPanel: {
			type: Boolean,
			default: false,
		},
		parentMessage: {
			type: String,
			required: true,
		},
		showSlots: Boolean,
		applicationLog: {
			type: Object,
			default: null,
		},
		selectedJob: {
			type: Object,
			default: null,
		},
		reschedule: {
			type: Boolean,
			default: false,
		},
	},
	mixins: [toast],
	data() {
		return {
			openModal: this.showSlots,
			availableSlots: this.generateAvailableSlots(),
			availableTimes: [],
			selectedDate: null,
			selectedTime: null,
			buttonClicked: false,
		};
	},
	created() {
		this.generateAvailableTimes(this.availableSlots[0].date);
	},
	methods: {
		async cancelInterview() {
			this.$emit("cancelInterview");
		},
		scrollLeft() {
			const container = document.querySelector(".select-date-parent");
			container.scrollLeft -= 100;
		},
		scrollRight() {
			const container = document.querySelector(".select-date-parent");
			container.scrollLeft += 100;
		},
		generateAvailableSlots() {
			let slots = [];
			let currentDate = new Date();
			const currentHour = currentDate.getHours();
			const currentMinutes = currentDate.getMinutes();
			if (currentHour > 21 || (currentHour === 21 && currentMinutes >= 45)) {
				currentDate.setDate(currentDate.getDate() + 1);
			}
			if (this.applicationLog && this.applicationLog.updatedAt) {
				const updatedAtDate = new Date(this.applicationLog.updatedAt);
				const timeDifference = currentDate - updatedAtDate;
				const daysDifference = Math.floor(
					timeDifference / (1000 * 60 * 60 * 24)
				);

				if (daysDifference === 0) {
					// If updatedAt is today, start from 2 days later
					currentDate.setDate(currentDate.getDate() + 2);
				} else if (daysDifference === 1) {
					// If updatedAt is 1 day before, start from tomorrow
					currentDate.setDate(currentDate.getDate() + 1);
				}
			}

			for (let i = 0; i < 5; i++) {
				let newDate = new Date(currentDate);
				newDate.setDate(currentDate.getDate() + i);
				slots.push({
					day: newDate.toLocaleDateString("en-US", { weekday: "long" }),
					date: newDate.toISOString().split("T")[0],
				});
			}
			return slots;
		},

		generateAvailableTimes(selectedDate) {
			let times = [];
			let startHour, startMinutes;
			const today = new Date().toISOString().split("T")[0];
			const isToday = selectedDate === today;
			if (this.applicationLog && this.applicationLog.updatedAt) {
				const updatedAtDate = new Date(this.applicationLog.updatedAt);
				const currentDate = new Date();
				const timeDifference = currentDate - updatedAtDate;
				const daysDifference = Math.floor(
					timeDifference / (1000 * 60 * 60 * 24)
				);

				if (daysDifference === 0 || daysDifference === 1) {
					startHour = 0;
					startMinutes = 0;
					selectedDate = new Date(updatedAtDate);
					selectedDate.setDate(updatedAtDate.getDate() + 2);
				} else {
					startHour = new Date().getHours();
					startMinutes = Math.ceil(new Date().getMinutes() / 15) * 15;
					selectedDate = new Date();
				}
			} else {
				if (isToday) {
					startHour = new Date().getHours();
					startMinutes = Math.ceil(new Date().getMinutes() / 15) * 15;
				} else {
					startHour = 0;
					startMinutes = 0;
				}
			}

			let endHour = 23;
			let currentTime = new Date(selectedDate);
			currentTime.setHours(startHour, startMinutes, 0, 0);

			while (
				currentTime.getHours() < endHour ||
				(currentTime.getHours() === endHour && currentTime.getMinutes() <= 45)
			) {
				times.push(
					currentTime.toLocaleTimeString("en-US", {
						hour: "2-digit",
						minute: "2-digit",
						hour12: true,
					})
				);
				currentTime.setMinutes(currentTime.getMinutes() + 15);
				if (currentTime.getHours() === 0 && currentTime.getMinutes() === 0) {
					break;
				}
			}
			this.availableTimes = times;
		},
		selectDate(slot) {
			this.selectedDate = slot;
			this.generateAvailableTimes(slot.date);
			if (!this.availableTimes.includes(this.selectedTime)) {
				this.selectedTime = null;
			}
		},
		selectTime(time) {
			this.selectedTime = time;
		},
		async confirmSelection() {
			if (this.buttonClicked) return;
			this.buttonClicked = true;
			if (this.selectedDate && this.selectedTime) {
				const selectedSlot = this.convertToUTC(
					this.selectedDate.date,
					this.selectedTime
				);
				const date = new Date();
				const parts = new Intl.DateTimeFormat("en-US", {
					timeZoneName: "short",
				}).formatToParts(date);
				const tz = parts.find((part) => part.type === "timeZoneName");
				const timeZone = tz.value.split(/[\+\-]/)[0];
				if (this.isPanel) {
					const payload = {
						preferredSlot: selectedSlot,
					};
					const response = await saveInterviewSlotPanel(payload);
					if (response.status == 200) {
						this.$emit("closeSlots");
						this.$emit("updateApplicationLog");
						this.buttonClicked = false;
					}
				} else {
					let payload;
					if (this.reschedule) {
						payload = {
							action: "rescheduleByPanel",
							interviewRequestID: this.selectedJob.interviewRequestID,
							slot: selectedSlot,
						};
					} else {
						payload = {
							jobID: this.selectedJob.jobID,
							customerID: this.selectedJob.customerID,
							licenseKey: this.selectedJob.licenseKey,
							slot: selectedSlot,
							timeZone: timeZone,
						};
					}
					const res = await saveInterviewSlot(payload);
					if (res.status === 200) {
						this.$emit("closeSlots");
						this.$emit("updateStatus", selectedSlot);
						this.selectedJob.slotStatus = 1;
						this.$nextTick(() => {
							let successMessage = "Slot selected successfully!";
							if (this.reschedule) {
								successMessage = "Reschedule request sent successfully!";
							}
							this.successModal("Success", successMessage);
						});
						this.buttonClicked = false;
					}
				}
			}
		},
		convertToUTC(selectedDate, selectedTime) {
			const [h, m, period] = selectedTime
				.match(/(\d+):(\d+)\s(AM|PM)/)
				.slice(1);
			let hours = (+h % 12) + (period === "PM" ? 12 : 0);
			let minutes = +m;
			let [year, month, day] = selectedDate.split("-").map(Number);

			const localDate = new Date(year, month - 1, day, hours, minutes);
			return localDate.toISOString();
		},
		formattedDate(dateString) {
			if (!dateString) return "Select a date";

			const date = new Date(dateString);
			if (isNaN(date)) return "Invalid date";

			const options = { day: "numeric", month: "short", year: "numeric" };
			let formatted = date.toLocaleDateString("en-GB", options);
			const day = date.getDate();
			const suffix = ["th", "st", "nd", "rd"][
				day % 10 > 3 || (day % 100 >= 11 && day % 100 <= 13) ? 0 : day % 10
			];

			return `${day}${suffix} ${formatted.split(" ").slice(1).join(" ")}`;
		},
	},
};
</script>

<style>
.interslot-body {
	padding: 20px;
}
.interslot-cross {
	position: absolute;
	right: 22px;
	top: 24px;
}
.interslot-body article {
	background: #ffe0744a;
	border-radius: 6px;
	padding: 10px 15px;
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #333333;
}
.interslot-body span {
	color: #344054;
}
.time-select-parent {
	height: 160px;
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	border-top: 1px solid #8c8c8c59;
}

.time-select-parent .single-time {
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #333333;
	text-align: center;
	padding-block: 20px;
	border: 2px solid #ffffff;
	border-bottom: 1px solid #8c8c8c59;
	width: 33.33%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}
.time-select-parent .single-time-sel,
.select-date-parent .single-time-sel {
	background-color: #f1f7ff;
	border: 2px solid #20639b;
	border-radius: 4px;
}

.time-select-parent .single-time-vertical-line {
	height: 50px;
	width: 1px;
	background-color: #8c8c8c59;
	position: absolute;
	right: 0px;
	top: 16px;
}
.select-date-parent {
	display: flex;
	gap: 20px;
	width: 100%;
	overflow-x: auto;
}
.select-date-parent::-webkit-scrollbar {
	scroll-behavior: smooth !important;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.single-time-date {
	color: #ffffff;
	border: 2px solid #8c8c8c59;
	box-shadow: 0px 2px 6px 0px #00000040;
	border-radius: 4px;
	width: 120px;
	padding-block: 7px;
	flex-shrink: 0;
}
.select-date-left {
	position: absolute;
	z-index: 4;
	left: -20px;
	top: 8px;
}
.select-date-right {
	position: absolute;
	z-index: 4;
	right: -20px;
	top: 8px;
}
.appr-modal-heading {
	text-align: center;
	color: #20639b;
	font-size: 20px;
	font-weight: 700;
}
.select-now-box {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 16px;
	background: rgba(32, 99, 155, 0.16);
	border-radius: 6px 6px 0px 0px;
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}
.select-now-text {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 14px;
	color: #20639b;
}
.gap-15 {
	gap: 15px;
}
.single-time-unsel {
	width: 185px;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.cancel-interview {
	font-family: "Montserrat";
	font-size: 13px;
	font-weight: 500;
	text-align: center;
	padding: 2px 10px;
	border-radius: 4px;
	line-height: 20px;
	background: rgba(255, 182, 180, 0.17);
	color: rgba(235, 0, 2, 1) !important;
}
</style>
